export default __webpack_public_path__ + "static/media/delete-modal.41483b4a.svg";